import axios from "axios";

export const state = {
    gradings: [],
};

export const getters = {
    gradings: state => state.gradings,
};

export const mutations = {
    setGrading(state, newValue) {
        state.gradings = newValue
    },
};

export const actions = {
    fetchGrading({ commit }) {
        axios.get('/gradingsytems').then(res => {
            commit('setGrading', res.data.gradings);
        })
    },
};
